import { Dictionary } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { GlPim, selectGlPimDictionary } from '@usf/ngrx-gl';
import { InventoryOptions } from '@usf/ngrx-inventory';
import { InventoryState } from '@usf/ngrx-inventory/lib/models/inventory/inventory.model';
import { Product } from '../../../../shared/models/product.model';
import { productSelector } from '../../../../shared/selectors/product.selectors';
import { InventoryViewModel } from '../../../models/inventory-view.model';
import {
  combineMapAndArrayForNonUSFProducts,
  convertToInventoryViewModel,
} from '../../../selectors/helpers/inventory-view-model-helper';
import {
  getAllNonUSFProductsAndConvertToFakeProducts,
  selectInventories,
} from '../../../selectors/inventory-view-model.selector';

export const selectSelectedInventory = () =>
  createSelector(
    selectInventories(),
    productSelector,
    selectGlPimDictionary,
    getAllNonUSFProductsAndConvertToFakeProducts,
    (
      inventories: InventoryState[],
      products: Map<number, Product>,
      glPimDictionary: Dictionary<GlPim>,
      nonUSFProducts: Product[],
    ) => {
      const prodMap = combineMapAndArrayForNonUSFProducts(
        products,
        nonUSFProducts,
      );

      let selectedInventory: InventoryViewModel = undefined;
      inventories?.forEach(inventory => {
        if (inventory.isSelected) {
          selectedInventory = convertToInventoryViewModel(
            inventory,
            { searchKey: undefined, selections: [] } as InventoryOptions,
            false,
            prodMap,
            glPimDictionary,
            {},
          );
        }
      });
      return selectedInventory;
    },
  );
